import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-fullscreen-overlay',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './fullscreen-overlay.component.html',
  styleUrl: './fullscreen-overlay.component.scss',
})
export class FullscreenOverlayComponent {
  @Input() isOverlayLoading!: boolean;
}
